import { render, staticRenderFns } from "./main_service_switcher.vue?vue&type=template&id=1ea7cb4e&scoped=true&"
import script from "./main_service_switcher.vue?vue&type=script&lang=js&"
export * from "./main_service_switcher.vue?vue&type=script&lang=js&"
import style0 from "./main_service_switcher.vue?vue&type=style&index=0&id=1ea7cb4e&scoped=true&lang=css&"
import style1 from "./main_service_switcher.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea7cb4e",
  null
  
)

export default component.exports